// @flow

import React from 'react';
import type { RouteStagePointWithResult } from 'type/type';
import SplitResult from '../SplitResult/SplitResult';
import './ResultList.scss';

type Props = {
  results: RouteStagePointWithResult[],
  isLive: boolean,
  isTriathlon: boolean,
}

const ResultList = ({ results, isLive, isTriathlon }: Props) => (
  <ul className="participant-result-list">
    {
      isLive
        ? results.map((r, i) => (
          <li key={r.id} className={i === 0 ? 'participant-result-list__current-point' : ''}>
            <SplitResult
              isTriathlon={isTriathlon}
              isLive={isLive}
              name={r.name}
              result={r.result}
              stageType={r.stageType}
              isStart={i === results.length - 1} />
          </li>))
        : results.map((r, i) => (
          <li key={r.id}>
            <SplitResult
              isTriathlon={isTriathlon}
              isLive={isLive}
              name={r.name}
              result={r.result}
              stageType={r.stageType}
              isStart={i === 0} />
          </li>))
    }
  </ul>
);

export default ResultList;
